// Utility functions for generating SEO-friendly slugs
import { format } from 'date-fns';

export function createSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function formatDateForSlug(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'd-MMM-yyyy').toLowerCase(); // e.g., "15-mar-2025"
}

export function createMatchSlug(homeTeam: string, awayTeam: string, kickoffTime?: string | Date): string {
  const teamsSlug = `${createSlug(homeTeam)}-vs-${createSlug(awayTeam)}`;
  if (kickoffTime) {
    return `${teamsSlug}-${formatDateForSlug(kickoffTime)}`;
  }
  return teamsSlug;
}

export function parseMatchSlug(slug: string): { homeTeam: string; awayTeam: string; date?: string } | null {
  // Try to match pattern: team-vs-team-DD-MMM-YYYY
  const dateMatch = slug.match(/^(.+)-vs-(.+)-(\d{1,2}-[a-z]{3}-\d{4})$/i);
  if (dateMatch) {
    return {
      homeTeam: dateMatch[1],
      awayTeam: dateMatch[2],
      date: dateMatch[3],
    };
  }
  
  // Fallback: legacy format without date
  const parts = slug.split('-vs-');
  if (parts.length !== 2) return null;
  
  return {
    homeTeam: parts[0],
    awayTeam: parts[1],
  };
}

export function parseDateFromSlug(dateSlug: string): Date | null {
  // Parse "15-mar-2025" format
  const match = dateSlug.match(/^(\d{1,2})-([a-z]{3})-(\d{4})$/i);
  if (!match) return null;
  
  const day = parseInt(match[1], 10);
  const monthStr = match[2].toLowerCase();
  const year = parseInt(match[3], 10);
  
  const months: Record<string, number> = {
    jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
    jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
  };
  
  const month = months[monthStr];
  if (month === undefined) return null;
  
  return new Date(year, month, day);
}
